import React from 'react'
import axios from '~/data/http/axios'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Column from '~/Common-Objects/Grids/Column/Column'
import Icons from '~/Common-Objects/UI/Icons/index'
import LoadingIcons from '~/Common-Objects/LoadingIcons/loadingIcon1'
import Paper from '~/Common-Objects/UI/Paper/Paper'
import Row from '~/Common-Objects/Grids/Row/Row'
import Select from '~/Common-Objects/UI/Forms/Select/Select'
import TextInput from '~/Common-Objects/UI/Forms/TextInput/TextInput'
import WarningHolder from '~/Common-Objects/UI/Cards/WarningHolder'
import { connect } from 'react-redux'
import copy from 'copy-to-clipboard'
import * as siteMaster from '~/data/actions/siteActions'
import DateTimeFunctions from '~/Classes/dateTimeFunctions'
import IncDisconnect from './incDisconnect'
import ChangeGroup from './changeGroup'
import ApplicationTransactionsGraph from '../components/applicationTransactionsGraph'
import AddApp from '../../addApp/'

const APP_ID = 92

@connect((store) => {
    return { user: store.user, permissionStore: store.permission, siteMaster: store.siteMaster }
})
export default class LittleBoxOfficeConfig extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoaded: false,
            appData: {},
            appBinding: {},
            groupData: [],
            groupId: -1,
            syncing: false,
            connectionError: '',
            syncError: '',
            marketingQuestions: [],
            consentQuestionId: 'all',
            consentSaving: false,
            consentError: '',
            webhookSecretDrafts: {},
            webhookSecretsConfigured: {},
            webhookSecretSavingEvent: '',
            webhookSecretError: '',
            webhookSecretEvents: ['order-completed', 'custom-form-submission', 'reservation-created'],
        }

        this.getApp = this.getApp.bind(this)
        this.getAppBinding = this.getAppBinding.bind(this)
        this.getGroups = this.getGroups.bind(this)
        this.getMarketingQuestions = this.getMarketingQuestions.bind(this)
        this.updateGroup = this.updateGroup.bind(this)
        this.resetGroup = this.resetGroup.bind(this)
        this.popDisconnect = this.popDisconnect.bind(this)
        this.goDisconnect = this.goDisconnect.bind(this)
        this.resync = this.resync.bind(this)
        this.updateConsentQuestion = this.updateConsentQuestion.bind(this)
        this.reAddApp = this.reAddApp.bind(this)
        this.saveWebhookSecret = this.saveWebhookSecret.bind(this)
        this.loadWebhookSecret = this.loadWebhookSecret.bind(this)
        this.copyWebhookUrl = this.copyWebhookUrl.bind(this)
        this.updateWebhookSecretDraft = this.updateWebhookSecretDraft.bind(this)
    }

    componentDidMount() {
        this.getApp()
    }

    getApp() {
        axios.get('/application/' + APP_ID).then((_theApp) => {
            this.setState({ appData: _theApp.data.Application }, this.getAppBinding)
        })
    }

    getAppBinding() {
        axios.get('/application/account/app/' + APP_ID).then((_theResp) => {
            var groupId = -1
            if (_theResp.data.Application.appSettings && _theResp.data.Application.appSettings.groupId) {
                groupId = _theResp.data.Application.appSettings.groupId
            }
            this.setState(
                {
                    appBinding: _theResp.data.Application,
                    groupId: groupId,
                    webhookSecretError: ''
                },
                () => {
                    this.loadWebhookSecret()
                    this.getGroups()
                }
            )
        })
    }

    loadWebhookSecret() {
        axios
            .get('/application/littleboxoffice/webhookSecret')
            .then((_resp) => {
                const events = _resp.data.events || this.state.webhookSecretEvents
                const configured = _resp.data.configured || {}
                const drafts = { ...this.state.webhookSecretDrafts }
                events.forEach((event) => {
                    if (drafts[event] === undefined) drafts[event] = ''
                })
                this.setState({
                    webhookSecretEvents: events,
                    webhookSecretsConfigured: configured,
                    webhookSecretDrafts: drafts,
                    webhookSecretError: '',
                })
            })
            .catch(() => {
                this.setState({ webhookSecretsConfigured: {} })
            })
    }

    updateWebhookSecretDraft(event, value) {
        this.setState({
            webhookSecretDrafts: {
                ...this.state.webhookSecretDrafts,
                [event]: value,
            },
            webhookSecretError: '',
        })
    }

    applyWebhookSecretSaved(configured) {
        const drafts = { ...this.state.webhookSecretDrafts }
        Object.keys(drafts).forEach((event) => {
            drafts[event] = ''
        })
        this.setState(
            {
                webhookSecretDrafts: drafts,
                webhookSecretsConfigured: configured || {},
                webhookSecretSavingEvent: '',
                webhookSecretError: '',
            },
            () => {
                axios.get('/application/account/app/' + APP_ID).then((_theResp) => {
                    this.setState({ appBinding: _theResp.data.Application })
                })
            }
        )
    }

    saveWebhookSecret(event) {
        const webhookSecret = ((this.state.webhookSecretDrafts && this.state.webhookSecretDrafts[event]) || '').trim()
        if (!webhookSecret) {
            this.setState({ webhookSecretError: 'Paste the secret generated in Little Box Office for ' + event + '.' })
            return
        }
        this.setState({ webhookSecretSavingEvent: event, webhookSecretError: '' })
        axios
            .post('/application/littleboxoffice/webhookSecret', { event, webhookSecret })
            .then((_resp) => {
                this.applyWebhookSecretSaved(_resp.data.configured)
            })
            .catch(() => {
                this.setState({
                    webhookSecretSavingEvent: '',
                    webhookSecretError: 'Could not save webhook secret. Please try again.',
                })
            })
    }

    getGroups() {
        axios.get('/group').then((_theGroups) => {
            this.setState({ groupData: _theGroups.data.Groups, isLoaded: true }, this.getMarketingQuestions)
        })
    }

    getMarketingQuestions() {
        axios
            .get('/application/littleboxoffice/marketingQuestions')
            .then((_theResp) => {
                const consentQuestionId =
                    _theResp.data.consentQuestionId != null && _theResp.data.consentQuestionId !== ''
                        ? String(_theResp.data.consentQuestionId)
                        : 'all'
                this.setState({
                    marketingQuestions: _theResp.data.questions || [],
                    consentQuestionId,
                    consentError: (_theResp.data.meta && _theResp.data.meta.error) || ''
                })
            })
            .catch((err) => {
                const data = err && err.response && err.response.data
                const apiError = (typeof data.error === 'string' && data.error) || (typeof data.message === 'string' && data.message) || ''
                this.setState({
                    marketingQuestions: [],
                    consentError: apiError
                })
            })
    }

    resetGroup() {
        this.setState({ groupId: -1 })
    }

    updateGroup(newGroupId, consentQuestionId, companyId, companyName) {
        var appBinding = this.state.appBinding
        if (!appBinding.appSettings) appBinding.appSettings = {}
        appBinding.appSettings.groupId = newGroupId
        if (companyId != null && companyId !== '' && companyId !== -1) {
            appBinding.appSettings.companyId = companyId
            if (companyName) appBinding.appSettings.companyName = companyName
        }
        if (consentQuestionId !== undefined) {
            appBinding.appSettings.consentQuestionId =
                consentQuestionId === '' ||
                consentQuestionId === '-1' ||
                consentQuestionId === 'all' ||
                consentQuestionId == null
                    ? null
                    : String(consentQuestionId)
        }
        this.setState({
            syncing: true,
            syncError: '',
            consentQuestionId: appBinding.appSettings.consentQuestionId || ''
        })
        axios
            .put('/application/account/' + this.state.appBinding.id, appBinding)
            .then(() => {
                return axios.get('/application/littleboxoffice/setupGroupAndImport')
            })
            .then(() => {
                this.setState({ groupId: newGroupId, syncing: false }, () => {
                    this.getAppBinding()
                    this.getGroups()
                })
            })
            .catch(() => {
                this.setState({ syncing: false, syncError: 'There was an error syncing your group. Please try again.' })
            })
    }

    resync() {
        this.setState({ syncing: true, syncError: '' })
        axios
            .get('/application/littleboxoffice/setup?resync=1')
            .then(() => {
                this.setState({ syncing: false }, this.getAppBinding)
            })
            .catch(() => {
                this.setState({ syncing: false, syncError: 'There was an error re-syncing. Please try again.' })
            })
    }

    updateConsentQuestion(consentQuestionId) {
        var appBinding = { ...this.state.appBinding }
        if (!appBinding.appSettings) appBinding.appSettings = {}
        const value =
            consentQuestionId === '' ||
            consentQuestionId === '-1' ||
            consentQuestionId === 'all' ||
            consentQuestionId == null
                ? null
                : String(consentQuestionId)
        appBinding.appSettings.consentQuestionId = value
        this.setState({ consentSaving: true, consentError: '', consentQuestionId: value || '' })
        axios
            .put('/application/account/' + appBinding.id, appBinding)
            .then(() => {
                this.setState({ appBinding, consentSaving: false })
            })
            .catch(() => {
                this.setState({
                    consentSaving: false,
                    consentError: 'Could not save the marketing consent field. Please try again.'
                })
            })
    }

    copyWebhookUrl() {
        const webhookUrl = (this.state.appBinding.appSettings && this.state.appBinding.appSettings.webhookUrl) || ''
        if (!webhookUrl) return
        copy(webhookUrl)
        this.props.dispatch(siteMaster.alterSnackbar(true, 'Copied to clipboard'))
    }

    popDisconnect() {
        this.props.dispatch(
            siteMaster.alterSiteDrawer(
                true,
                true,
                'right',
                <IncDisconnect goDisconnect={this.goDisconnect} />,
                true,
                '500px'
            )
        )
    }

    goDisconnect() {
        axios.get('/application/littleboxoffice/disconnect').then(() => {
            this.props.history.push('/cp/company/integrations')
        })
    }

    reAddApp() {
        var drawer = (
            <AddApp
                history={this.props.history}
                reconnect={true}
                appId={APP_ID}
                browse={(url) => {
                    this.props.dispatch(siteMaster.alterSiteDrawer(false, true, 'right', null, false))
                    this.props.history.push(url)
                    this.setState({ connectionError: '', isLoaded: false }, this.getAppBinding)
                }}
            />
        )
        this.props.dispatch(siteMaster.alterSiteDrawer(true, true, 'right', drawer, false, '100vw', 'full'))
    }

    render() {
        if (!this.state.isLoaded)
            return (
                <div>
                    <LoadingIcons iconType='2' />
                </div>
            )

        if (this.state.connectionError) {
            return (
                <div>
                    <Row>
                        <Column xs={12} sm={12} md={8} lg={8} className='col-md-offset-2'>
                            <Paper>
                                <WarningHolder className='mar-b25' style={{ textAlign: 'left' }}>
                                    <p className='mar-b10'>{this.state.connectionError}</p>
                                    <Button
                                        className='button-sml red outline'
                                        text='Reconnect'
                                        onClick={this.reAddApp}
                                    />
                                </WarningHolder>
                            </Paper>
                        </Column>
                    </Row>
                </div>
            )
        }

        var currentGroup = this.state.groupData.find((theRow) => theRow.id == this.state.groupId)
        if (this.state.groupId == '' || this.state.groupId == '-1' || !currentGroup) {
            return (
                <ChangeGroup
                    appBinding={this.state.appBinding}
                    updateGroup={this.updateGroup}
                    onReconnect={this.reAddApp}
                />
            )
        }

        const appSettings = this.state.appBinding.appSettings || {}
        const webhookUrl = appSettings.webhookUrl || ''
        const webhookDocsUrl = appSettings.webhookDocsUrl || 'https://api.nuwebgroup.com/webhooks/docs'
        const recommendedEvents = appSettings.recommendedWebhookEvents || [
            'order-completed',
            'custom-form-submission',
            'reservation-created'
        ]
        const consentOptions = [
            { label: 'All marketing yes/no questions (default)', value: 'all' },
            ...this.state.marketingQuestions.map((q) => ({
                label: q.label || `Question ${q.id}`,
                value: String(q.id)
            }))
        ]
        const selectedConsentQuestionId = this.state.consentQuestionId || 'all'
        if (
            selectedConsentQuestionId &&
            selectedConsentQuestionId !== 'all' &&
            !consentOptions.some((o) => String(o.value) === selectedConsentQuestionId)
        ) {
            consentOptions.push({
                label: `Question ${selectedConsentQuestionId} (saved)`,
                value: selectedConsentQuestionId
            })
        }

        return (
            <div>
                <Row className='middle-xs mar-b10'>
                    <Column xs={12} sm={12} md={4} lg={4} className='col-md-offset-2'>
                        <div className='quickFlex'>
                            <div
                                className='integration-avatar rounded'
                                style={{ backgroundImage: 'url(' + this.state.appData.appLogoUri + ')' }}
                            ></div>
                            <p className='no-marg pad-left'>
                                Little Box Office is connected as "<strong>{appSettings.companyName}</strong>"
                            </p>
                        </div>
                    </Column>
                    <Column xs={12} sm={12} md={4} lg={4} className='end-xs'>
                        <p className='no-marg'>
                            <Button className='button-sml grey' onClick={this.popDisconnect}>
                                Disconnect
                            </Button>
                        </p>
                    </Column>
                </Row>

                <Row className='mar-b20'>
                    <Column xs={12} sm={12} md={4} lg={4} className='col-md-offset-2'>
                        <Paper className='height-100 mar-b0'>
                            <h4 className='text-primary mar-b10'>Contacts</h4>
                            <p>
                                Little Box Office is syncing customers into the following group. Customer updates and
                                ticket purchases in LBO are reflected here automatically.
                            </p>
                            <p>
                                <div
                                    className='chip smallChip outline secondary'
                                    onClick={() => {
                                        this.props.history.push('/cp/groups/' + this.state.groupId)
                                    }}
                                >
                                    {currentGroup.groupName}
                                </div>
                                {!this.state.syncing &&
                                    this.state.appBinding.appSettings &&
                                    this.state.appBinding.appSettings.lastSynced && (
                                        <div className='text-xsml'>
                                            Last synced:{' '}
                                            {DateTimeFunctions.formatDateTime(
                                                this.state.appBinding.appSettings.lastSynced,
                                                1
                                            )}{' '}
                                            - <a onClick={this.resync}>Re-sync</a>
                                        </div>
                                    )}
                            </p>
                            <p className='no-marg'>
                                <Button
                                    className='full-width button-md outline primary'
                                    onClick={this.resetGroup}
                                >
                                    Change Group
                                </Button>
                            </p>
                            {this.state.syncError && <p className='text-error mar-t10'>{this.state.syncError}</p>}
                            {this.state.syncing && (
                                <div style={{ marginTop: '10px' }}>
                                    <p>Performing sync…</p> <LoadingIcons iconType='2' />
                                </div>
                            )}
                        </Paper>
                    </Column>
                    <Column xs={12} sm={12} md={4} lg={4}>
                        <Paper className='height-100 mar-b0'>
                            <h4 className='text-primary mar-b10'>Sync history</h4>
                            <ApplicationTransactionsGraph applicationId={this.state.appData.id} />
                        </Paper>
                    </Column>
                </Row>

                <Row className='mar-b20'>
                    <Column xs={12} sm={12} md={8} lg={8} className='col-md-offset-2'>
                        <Paper className='height-100 mar-b0'>
                            <h4 className='text-primary mar-b10'>Marketing consent</h4>
                            <p>
                                Choose which Little Box Office marketing question is the point of truth for
                                subscribe/unsubscribe status in Transpond. By default, every marketing yes/no question
                                is considered.
                            </p>
                            <div className='form-group mar-b10' style={{ maxWidth: '500px' }}>
                                <Select
                                    data={consentOptions}
                                    name='consentQuestionId'
                                    value={selectedConsentQuestionId}
                                    disabled={this.state.consentSaving}
                                    onChange={(e) => {
                                        this.updateConsentQuestion(e.target.value)
                                    }}
                                />
                            </div>
                            {!this.state.marketingQuestions.length && (
                                <p className='text-xsml'>
                                    No marketing questions found yet. They appear after customers with marketing
                                    preferences sync from Little Box Office.
                                </p>
                            )}
                            {this.state.consentSaving && <p className='text-xsml'>Saving…</p>}
                            {this.state.consentError && <p className='text-error'>{this.state.consentError}</p>}
                            <p className='text-xsml mar-b0'>
                                Re-sync contacts after changing this so existing subscribers pick up the new consent
                                source.
                            </p>
                        </Paper>
                    </Column>
                </Row>

                <Row className='mar-b20'>
                    <Column xs={12} sm={12} md={8} lg={8} className='col-md-offset-2'>
                        <Paper className='height-100 mar-b0'>
                            <h4 className='text-primary mar-b10'>Webhooks</h4>
                            <p>
                                Register this URL in your Little Box Office admin (System → Webhooks) to receive live
                                customer and order updates. Little Box Office only needs to <strong>POST</strong> to
                                this endpoint — no PUT, PATCH, or other methods are required.
                            </p>

                            <Paper>
                                <div className='text-heavy mar-b15'>Setup Instructions</div>
                                <p className='text-xsml mar-b15'>
                                    In Little Box Office, create a separate webhook for each event below. Use the same
                                    URL for all of them, and paste each webhook&apos;s secret here.
                                </p>
                                {webhookUrl && (
                                    <TextInput
                                        label='Webhook URL'
                                        value={webhookUrl}
                                        readOnly={true}
                                        outerClassName='mar-b15'
                                        iconRight={<Icons icon='copyClipboard' onClick={this.copyWebhookUrl} />}
                                    />
                                )}
                                <p className='text-xsml mar-b15'>
                                    <strong>HTTP method:</strong> POST
                                </p>
                                {(this.state.webhookSecretEvents || recommendedEvents).map((event) => {
                                    const configured = !!(
                                        this.state.webhookSecretsConfigured && this.state.webhookSecretsConfigured[event]
                                    )
                                    const saving = this.state.webhookSecretSavingEvent === event
                                    return (
                                        <Paper key={event} className='mar-b15 pad-10'>
                                            <div className='text-xsml mar-b10'>
                                                <strong>{event}</strong>
                                                {configured ? (
                                                    <span className='text-success'> — secret saved</span>
                                                ) : (
                                                    <span> — secret not saved</span>
                                                )}
                                            </div>
                                            <div className='quickFlex middle-xs'>
                                                <div style={{ flexGrow: 1 }}>
                                                    <TextInput
                                                        type='password'
                                                        name={'webhookSecret_' + event}
                                                        outerClassName='mar-r10 mar-b0'
                                                        placeholder={
                                                            configured
                                                                ? 'Paste a new secret to replace'
                                                                : 'Paste secret from Little Box Office'
                                                        }
                                                        value={
                                                            (this.state.webhookSecretDrafts &&
                                                                this.state.webhookSecretDrafts[event]) ||
                                                            ''
                                                        }
                                                        disabled={!!this.state.webhookSecretSavingEvent}
                                                        onChange={(e) => {
                                                            this.updateWebhookSecretDraft(event, e.target.value)
                                                        }}
                                                    />
                                                </div>
                                                <Button
                                                    className='button-sml primary'
                                                    text={saving ? 'Saving…' : configured ? 'Replace' : 'Save'}
                                                    disabled={!!this.state.webhookSecretSavingEvent}
                                                    onClick={() => {
                                                        this.saveWebhookSecret(event)
                                                    }}
                                                />
                                            </div>
                                        </Paper>
                                    )
                                })}
                            </Paper>
                            {this.state.webhookSecretError && (
                                <p className='text-error mar-t10 mar-b0'>{this.state.webhookSecretError}</p>
                            )}
                        </Paper>
                    </Column>
                </Row>

                <Row className='mar-b60'>
                    <Column xs={12} sm={12} md={8} lg={8} className='col-md-offset-2'>
                        <Paper className='height-100 mar-b0'>
                            <Row>
                                <Column xs={12} margin={0}>
                                    <h4 className='text-primary mar-b10'>Segments &amp; Automations</h4>
                                    <p>
                                        Use synced LBO custom fields (such as last purchase date, guest status, and
                                        booked categories) in the standard segment and automation editors.
                                    </p>
                                    <p>
                                        <Button
                                            text='View Automations'
                                            className='button-sml'
                                            onClick={() => {
                                                this.props.history.push('/cp/automation')
                                            }}
                                        />
                                    </p>
                                </Column>
                            </Row>
                        </Paper>
                    </Column>
                </Row>
            </div>
        )
    }
}
